import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';

export const serviceComputed = {
	...mapState('daemonProcessManagementStore', Object.keys(state)),
	...mapGetters('daemonProcessManagementStore', Object.keys(getters))
};
export const serviceMethods = {
	...mapActions('daemonProcessManagementStore', Object.keys(actions)),
	...mapMutations('daemonProcessManagementStore', Object.keys(mutations))
};
